const TRACKER_OPTIONS_FINANCING = {
  origin: '(Modal) Confirmação do pedido, originado de Financiamento por Valor',
}

const TRACKER_OPTIONS_DEFAULT = { origin: '(Modal) Confirmação do pedido' }

export { TRACKER_OPTIONS_DEFAULT, TRACKER_OPTIONS_FINANCING }
